/**
 * @voltxampere/ui — STM32F103C8 (Blue Pill) variant (Sprint 43-5, placeholder)
 *
 * PLACEHOLDER. Full GPIO + ADC + PWM + I2C + SPI + USB simulation
 * arrives Sprint 46+ (ARM Cortex-M3 family).
 *
 * Reference: ST STM32F103C8T6, LQFP-48. ARM Cortex-M3 32-bit.
 * Vcc 2.0-3.6 V, fmax 72 MHz, 64 KB Flash / 20 KB SRAM, 37 GPIO,
 * 2× 12-bit ADC (10 channels each), USB FS, 3× UART / 2× SPI / 2× I2C.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuStm32f103c8 = {
    id: "stm32f103c8",
    nameTr: "STM32F103C8 (Blue Pill, LQFP-48, placeholder)",
    nameEn: "STM32F103C8 (Blue Pill, LQFP-48, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "STM32F103C8",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 3.3,
        vLow: 0,
        threshold: 1.65,
        propagationDelay: 14e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-stm32f103c8.js.map